(function (angular) {
    'use strict';

    angular.module('Common')

        .factory('HttpInterceptor', ['$q', '$location', '$injector', function ($q, $location, $injector) {

            return {
                /**
                 * If we get any 401 back, redirect to the login page
                 */
                responseError: function (rejection) {
                    if (rejection.status === 401 && rejection.config.url.indexOf('/authenticate') == -1) {
                        console.error("Response Error 401", rejection);
                        var jwtService = $injector.get('jwtService');
                        var $state = $injector.get('$state');
                        if (!jwtService.payload || !jwtService.payload.sub) {
                            $state.go('login', { "link": $location.path() });
                        }
                        else {
                            var modal = $injector.get('$uibModal').open({
                                templateUrl: 'shared/login/relogin.html',
                                controller: 'ReLoginController',
                                size: 'sm',
                                backdrop: 'static',
                                keyboard: false
                            });
                            return modal.result.then(function () {
                                var $http = $injector.get('$http');
                                var config = rejection.config;
                                config.headers.Authorization = 'Bearer ' + jwtService.token;
                                return $http(config);
                            }, function () {
                                if ($state.current.name != "login") $state.go('login', { "link": $location.path() });
                                return $q.reject(rejection);
                            });
                        }
                    }
                    else if (rejection.status === 403) {
                        console.warn("Response Error 403", rejection);
                        if ($injector.get('$state').current.name != "accessDenied") $injector.get('$state').go('accessDenied');
                    }
                    else if (typeof rejection.data === 'string') {
                        rejection.statusText = rejection.data;
                    }
                    else if (rejection.data && rejection.data.error && rejection.data.error.message) {
                        rejection.statusText = rejection.data.error.message;
                        rejection.customMessage = true;
                    }
                    else if (rejection.data && rejection.data.validationFailures) {
                        var statusText = '';
                        for (var i in rejection.data.validationFailures) {
                            statusText = statusText + rejection.data.validationFailures[i].message + '. ';
                        }
                        rejection.statusText = statusText;
                        rejection.customMessage = true;
                    }
                    else if (rejection.status >= 500) {
                        rejection.statusText = "There was a problem applying your change. Please try again. If the problem persists, please contact Support";
                        rejection.customMessage = true;
                    }
                    return $q.reject(rejection);
                },
                response: function (response) {
                    if (response.config.billing && !$injector.get('sharedDataService').isInvoiced) {
                        $injector.get('coreDataService').getBilling($injector.get("jwtService").payload.accountId);
                    }
                    return response;
                },
                /**
                 * Add an auth header to all requests if we have a token
                 */
                request: function (config) {
                    // generates a circular reference if injected into the factory ...
                    // TODO: review this at some point ...
                    function addHeaders() {
                        //should prevent from caching in IE/Edge
                        config.headers["Cache-Control"] = "no-cache";
                        config.headers["Pragma"] = "no-cache";
                        config.headers["If-Modified-Since"] = "Mon, 26 Jul 1997 05:00:00 GMT";

                        if (jwtService.token && !config.headers.Authorization && !config.url.includes('.html')) {
                            config.headers.Authorization = 'Bearer ' + jwtService.token;
                        }

                        return config;

                    }
                    var jwtService = $injector.get("jwtService");
                    var callsService = $injector.get('callsService');
                    if (callsService.isModalOpen() && !config.url.includes('.html') && !config.url.includes('authenticate')) {
                        return callsService.addPendingCall(config).then(function (result) {
                            config = result;
                            return addHeaders();
                        }).catch(function () {
                            var canceller = $q.defer();
                            config.timeout = canceller.promise;
                            canceller.resolve();
                            return config;
                        });
                    }
                    else {
                        return addHeaders();
                    }
                }
            };
        }])
        /**
         * 
         */
        .factory('CacheBusterInterceptor', ['portalConfig', function (portalConfig) {

            return {
                'request': function (config) {
                    // !!config.cached represents if the request is resolved using 
                    //      the angular-templatecache
                    if (!config.cached) {
                        // portalConfig.versionNumber will be undefined in unit test context
                        // (adding query string will break all tests that use template cache)
                        if (config.url.includes('.html') && portalConfig.versionNumber) {

                            // ANY templates found in these folders will get ?v=x.y.z appended to them
                            // the version number is just pulled out of package.json from the root (wired up through config.ejs) 
                            var inclusionList = ["components", "shared"];

                            var found = false;

                            inclusionList.forEach(function (path) {
                                if (config.url.indexOf(path) === 0) {
                                    found = true;
                                }
                            });

                            if (found) {
                                config.url += ((config.url.indexOf('?') > -1) ? '&' : '?')
                                    + config.paramSerializer({ v: portalConfig.versionNumber });
                            }
                        }
                    } else if (config.url.indexOf('no-cache') > -1) {
                        // if the cached URL contains 'no-cache' then remove it from the cache
                        config.cache.remove(config.url);
                        config.cached = false; // unknown consequences
                        // Warning: if you remove the value form the cache, and the asset is not
                        //          accessable at the given URL, you will get a 404 error.
                    }
                    return config;
                }
            }
        }]);




})(window.angular);
